"use strict";
/**
 * In here are snippets functions and helper to abstract some api code that is otherwise boilerplate
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._GetOfferings = void 0;
var api_wrapper_1 = require("../api/api-wrapper");
var object_service_1 = require("../services/object-service");
var settings_service_1 = require("../services/settings.service");
var generator_const_1 = require("./dom-crud/generator.const");
var error_helper_const_1 = require("./error-handling/error-helper.const");
var input_output_helper_const_1 = require("./input-output-helper.const");
var input_mapping_const_1 = require("./input.mapping.const");
/**
 * Returns the offerings for current studio if set in localstorage or if given via function parameter
 * @param studioId
 * @param studioName
 * @returns CurrentOfferings | undefined
 */
var _GetOfferings = function (studioId, studioName) { return __awaiter(void 0, void 0, void 0, function () {
    var apiWrapper, config, returnObject, _a, hideMembershipNames_1, e_1;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return __generator(this, function (_p) {
        switch (_p.label) {
            case 0:
                apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
                config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
                returnObject = {};
                returnObject.studioId = String((0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId) || ((_c = (_b = config.get) === null || _b === void 0 ? void 0 : _b.overwriteValues) === null || _c === void 0 ? void 0 : _c.studioId) || ((_d = config.get) === null || _d === void 0 ? void 0 : _d.studioId) || '');
                returnObject.studioName = String((0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioName) || ((_f = (_e = config.get) === null || _e === void 0 ? void 0 : _e.overwriteValues) === null || _f === void 0 ? void 0 : _f.studioName) || ((_g = config.get) === null || _g === void 0 ? void 0 : _g.studioName) || '');
                //console.log("loaded studioId", returnObject, "with local being", _ReadFieldValue(_AllMappings.studioId), "overwrite", config.get?.overwriteValues?.studioId, "and set", config.get?.studioId)
                if (!((_h = returnObject.studioId) === null || _h === void 0 ? void 0 : _h.length)) {
                    console.error('No studio id is set');
                    return [2 /*return*/];
                }
                if (!((_j = returnObject.studioName) === null || _j === void 0 ? void 0 : _j.length)) {
                    console.info('No studio name is set');
                }
                (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioId, returnObject.studioId);
                (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioName, returnObject.studioName);
                (0, generator_const_1._CreateLoadingScreen)();
                _p.label = 1;
            case 1:
                _p.trys.push([1, 3, , 4]);
                _a = returnObject;
                return [4 /*yield*/, apiWrapper.getOfferings(returnObject.studioId)];
            case 2:
                _a.offerings = _p.sent();
                hideMembershipNames_1 = (_m = (_l = (_k = config.get) === null || _k === void 0 ? void 0 : _k.checkout) === null || _l === void 0 ? void 0 : _l.hideMembershipNames) !== null && _m !== void 0 ? _m : [];
                if (hideMembershipNames_1.length) {
                    returnObject.offerings = returnObject.offerings.filter(function (offering) {
                        var _a, _b;
                        var offeringName = (_b = (_a = offering.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
                        return !hideMembershipNames_1.some(function (hiddenName) { return offeringName.includes(hiddenName.toLowerCase()); });
                    });
                }
                return [3 /*break*/, 4];
            case 3:
                e_1 = _p.sent();
                console.error('Failed getting offerings', e_1);
                return [3 /*break*/, 4];
            case 4:
                (0, generator_const_1._DeleteLoadingScreen)();
                if (((_o = returnObject.offerings) === null || _o === void 0 ? void 0 : _o.length) === 0 || returnObject.offerings === undefined) {
                    (0, error_helper_const_1._ShowGloballyErrorMessage)("No offerings found for studio \"".concat(returnObject.studioId, "\" using the \"").concat(config.get.technologyType, "\" API"));
                    return [2 /*return*/];
                }
                else {
                    (0, error_helper_const_1._HideGloballyErrorMessage)();
                }
                return [2 /*return*/, returnObject];
        }
    });
}); };
exports._GetOfferings = _GetOfferings;
